import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { EverestBaseCampPage } from './pages/EverestBaseCampPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { DestinationNepalPage } from './pages/DestinationNepalPage';
import { ActivitiesPage } from './pages/ActivitiesPage';
import { SpiritualJourneysPage } from './pages/SpiritualJourneysPage';
import { EverestTrekGuidePage } from './pages/EverestTrekGuidePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { SitemapPage } from './pages/SitemapPage';
import { PlanTripPage } from './pages/PlanTripPage';
import { EverestRegionTreksPage } from './pages/EverestRegionTreksPage';
import { FamilyHolidaysPage } from './pages/FamilyHolidaysPage';
import { OurTeamPage } from './pages/OurTeamPage';
import { WhyChooseUsPage } from './pages/WhyChooseUsPage';
import { LegalDocumentsPage } from './pages/LegalDocumentsPage';
import { PackingListPage } from './pages/PackingListPage';
import { AltitudeSicknessPage } from './pages/AltitudeSicknessPage';
import { PhotographyTipsPage } from './pages/PhotographyTipsPage';
import { NepalVisaPage } from './pages/NepalVisaPage';
import { ChoosingAgencyPage } from './pages/ChoosingAgencyPage';
import { PostTrekRecoveryPage } from './pages/PostTrekRecoveryPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1) || 'home';
      setCurrentPage(hash);
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const renderPage = () => {
    switch (currentPage) {
      case 'about':
        return <AboutPage data-id="element-0" />;
      case 'contact':
        return <ContactPage data-id="element-1" />;
      case 'everest-base-camp':
        return <EverestBaseCampPage data-id="element-2" />;
      case 'blog-everest-gear':
        return <BlogPostPage data-id="element-3" />;
      case 'destination-nepal':
        return <DestinationNepalPage data-id="element-4" />;
      case 'activities':
        return <ActivitiesPage data-id="element-5" />;
      case 'spiritual-journeys':
        return <SpiritualJourneysPage data-id="element-6" />;
      case 'everest-trek-guide':
        return <EverestTrekGuidePage data-id="element-7" />;
      case 'privacy-policy':
        return <PrivacyPolicyPage data-id="element-8" />;
      case 'terms-of-use':
        return <TermsOfUsePage data-id="element-9" />;
      case 'sitemap':
        return <SitemapPage data-id="element-10" />;
      case 'plan-trip':
        return <PlanTripPage data-id="element-11" />;
      case 'everest-region-treks':
        return <EverestRegionTreksPage data-id="element-12" />;
      case 'family-holidays':
        return <FamilyHolidaysPage data-id="element-13" />;
      case 'our-team':
        return <OurTeamPage data-id="element-14" />;
      case 'why-choose-us':
        return <WhyChooseUsPage data-id="element-15" />;
      case 'legal-documents':
        return <LegalDocumentsPage data-id="element-16" />;
      case 'packing-list':
        return <PackingListPage data-id="element-17" />;
      case 'altitude-sickness':
        return <AltitudeSicknessPage data-id="element-18" />;
      case 'photography-tips':
        return <PhotographyTipsPage data-id="element-19" />;
      case 'nepal-visa':
        return <NepalVisaPage data-id="element-20" />;
      case 'choosing-agency':
        return <ChoosingAgencyPage data-id="element-21" />;
      case 'post-trek-recovery':
        return <PostTrekRecoveryPage data-id="element-22" />;
      default:
        return <HomePage data-id="element-23" />;
    }
  };
  return renderPage();
}